var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.82486V4.7131M9 11.8725V11.9087M14.1974 15.3332H3.80256C2.38268 15.3332 1.18443 14.3948 0.807432 13.1109C0.646501 12.5629 0.844241 11.992 1.1467 11.506L6.34413 2.13411C7.56184 0.1773 10.4382 0.177303 11.6559 2.13411L16.8533 11.506C17.1558 11.992 17.3535 12.5628 17.1926 13.1109C16.8156 14.3948 15.6173 15.3332 14.1974 15.3332Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.14aa8abdbe7a217fb03df02a7b11d3ab.svg";
export { ForwardRef as ReactComponent };